import { postRequest } from '../../utils/api'
import { getRequest } from '../../utils/api'
import { postRequest2 } from '../../utils/api'

// //获取省列表数据
// export function postProvinces() {
//     return postRequest(
//         `/dim/queryAllProvince`
//     )
// }
 //获取市列表数据 '/dim/dim_table_char/sex'
export function dictionaries(params) {
    return postRequest(
        `/dim/dim_table_char/${params}`,
    )
}
//货（商）品列表(多条件查询)
export function goodsList(currentPage, limit, goodsName) {
    return getRequest(
        `/jxc/goodsList?page=${currentPage}&limit=${limit}&goodsName=${goodsName}`,
    )
}
//货（商）品新增
export function addGoods(params) {
    return postRequest2(
        `/jxc/addGoods`,
        params
    )
}
//货（商）品修改（jxc/updateGoods）
export function updateGoods(params) {
    return postRequest2(
        `/jxc/updateGoods`,
        params
    )
}
//删除货（商）品（jxc/deleteGoods）
export function deleteGoods(params) {
    return postRequest2(
        `/jxc/deleteGoods`,
        params
    )
}
//（单个）供应商信息查询
export function querySupplier(params) {
    return getRequest(
        `/jxc/querySupplier?id=${params}`,
    )
}

